module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAuCAYAAADtGqNXAAAAYUlEQVQoU2NkqPzfyfCfIZeBkWEiI0PF/18MDAysDAwMv0Gc/wxQMMphYKBlGHSW1//P/T+LYSJjOgPjrzLR/6wMfxh+M7AwMP4vE0TEwiDjoDj0bJn9Ki2GmyHXGNRXAwAf+n5zxqOkjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/footerrg.png
// module id = Jf0w
// module chunks = 1